import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import utils from 'utils';
import actions from 'state/actions';
import { actionType } from 'utils/constants';

import CommonButton from 'components/Buttons/CommonButton';
import selectors from 'state/selectors';

const AddReportNotification = () => {
  const dispatch = useDispatch();
  const t = utils.intl.useTranslator();

  const selectedRow = useSelector(selectors.configurator.getSelectedReportSettings);
  const formMode = useSelector(selectors.configurator.getFormModeReports);

  return (
    <CommonButton
      id="add-report-notification"
      action={() => dispatch(actions.configurator.setFormModeReport('add'))}
      scope="tertiary"
      value={t(actionType.ADD_REPORTS_NOTIFICATION)}
      customIcon="plus"
      disabled={!utils.user.isActionByCompanyActive(actionType.ADD_REPORTS_NOTIFICATION) || !!selectedRow || !!formMode}
    />
  );
};

export default AddReportNotification;
